
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAACBUExURQAAAP////////////////////////////////// //////j4+9Pa58XO39vg6/Dy97bB14udwLbB2JmpyJKjxKGwzKi20JqpyLfC1+nt89Ta5/j5+8XO 4Ki10K+706i1z/Hz98XN36GvzM3U48zU46+81OLm77fC2Nvh69Pb5wAAANjsfXMAAAAKdFJOUwBA j9/PnyAQkD+yeUh8AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cM BAM5IlSlicsAAAD8SURBVCjPhZJtc4MgDIAjvnWZqCmsWOkLtd26/f8/uKh3Wpjcng8c8BBygQAw iUjRI8sLmCl3uIEoJ5fhJtlodxhBABQYJYE8LgW8ZHyvpKybdZ3Cqlqa2K96kY0i0h8HTaSaUDbK dHTkSW9I2UC2tMfT+XKt0GmeerLhZDc88Tjgnch6siZ9PN+w74geVlPvSUkHvFKF2NEnDiQDOeBl zNVOp3xZkbYPrpFr7VFT7UnLufg6xvBBcn4pHekvNcqhVvQM6rSGFowLn8+ZP26V6LrZPe2yBS+t 5b6l/FkVZiDin51DEpfcntFQ8V9rQrkZOzc1U+RBdCrexv1fK9kkX6s156wAAAAldEVYdGRhdGU6 Y3JlYXRlADIwMjMtMTItMDRUMDI6MzI6MTErMDA6MDBnkLLfAAAAJXRFWHRkYXRlOm1vZGlmeQAy MDIzLTEyLTA0VDAyOjMyOjExKzAwOjAwFs0KYwAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMy0x Mi0wNFQwMzo1NzozNCswMDowMILP2+QAAAAASUVORK5CYII="}})])
          )
        }
      }
    